import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path fill="currentColor" d="M14 10a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 9v12H3a1 1 0 0 0-1 1v2a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3v-2a1 1 0 0 0-1-1h-1V9a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3m3-1a1 1 0 0 0-1 1v12h20V9a1 1 0 0 0-1-1zm21 15v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconWeb = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeb);
export default Memo;
